import { GoogleAddressComponentsFields } from "./googleAddressFields";

export const AddressSectionFields = {
	...GoogleAddressComponentsFields,
	SearchAddress: { name: "search_address", displayName: "Search Address" },
	Apartments: { name: "apartments", displayName: "Apt, Suite, etc" },
	TypeOfLocation: {
		name: "type_of_location",
		displayName: "Type of Location",
	},
	OtherTypeOfLocation: {
		name: "location_if_other",
		displayName: "Other Type of Location",
	},
};
